var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-link',{attrs:{"to":"/myaccount/segmentGifts"}},[_c('notifications',{attrs:{"position":"top left"}})],1),_c('Header'),_c('router-view'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }